// extracted by mini-css-extract-plugin
module.exports = {"wrapperInfoPlayer":"documentView_wrapperInfoPlayer__1CScp","wrapperTab":"documentView_wrapperTab__2SYBQ","col":"documentView_col__2tdVk","colTabs":"documentView_colTabs__3o0km"};